<template>
  <div class="user-info">
    <gjw-dialog
      title="构件坞个人信息补充"
      :show-dialog="showUserDetail"
      customClass="user-info-dialog"
      :show-footer="false"
      width="800px"
      @close="setShowUserDetail(false)">
      <iframe
        :src="url" 
        frameborder="0" 
        scrolling="auto" 
        class="user-info-iframe"
        width="800px"
        height="500px" />
    </gjw-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import GjwDialog from '@/components/lib/GjwDialog'
export default {
  name: 'UserDetail',
  components: { GjwDialog },
  data() {
    const env = process.env.NODE_ENV
    return {
      url: env === 'development' ? 'https://personal-local.goujianwu.com:4009/#/user/detail' : `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user/detail`
    }
  },
  mounted() {
    window && window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    ...mapMutations({
      setShowUserDetail: 'user/setShowUserDetail'
    }),
    receiveMessage(event) {
      if (!event.data || typeof event.data !== 'string') { return }
      const origin = event.origin
      const env = process.env.NODE_ENV
      if (env !== 'development') {
        if (origin !== process.env.VUE_APP_GJW_PORTAL_URL) { return }
      }
      const data = event.data ? JSON.parse(event.data) : {}
      if (data.eventId === 'saveDetail') {
        data.saved ? this.setShowUserDetail(false) : this.$message.error('保存失败')
      }
    },
  },
  computed: {
    ...mapGetters({
      showUserDetail: 'user/showUserDetail'
    })
  }
}
</script>
<style lang='less' scoped>
.user-info-dialog{
  width: 800px;
  height: 500px;
}

/deep/.el-dialog__body{
    padding: 0;
  }
  /deep/.el-dialog__headerbtn{
    font-size: 20px;
  }
</style>
